import {AvalancheServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheServerDataParser";
import {IGGGameData} from "./data/IGGServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IBetWinData, IGameData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";

export class GGServerDataParser extends AvalancheServerDataParser {

    constructor() {
        super();
    }

    public parseBetWins(rawData:IGameData):IBetWinData[] {
        if(!GameConfig.instance.BET_WIN_MODE) {
            throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
        return rawData.betWayWins!;
    }

    public parseSingleWin(rawData:IGGGameData):number {
        return parseFloat(rawData.thisAvalancheWinnings);
    }

    public parseAvalancheTotalWin(rawData:IGGGameData):number {
        return parseFloat(rawData.totalAvalancheRoundWinnings);
    }

    // #529
    public parseNearWinPositions(rawData: IGGGameData): boolean[][] {
        let retVal: boolean[][] = super.parseNearWinPositions(rawData);

        // if feature buy is non double spins then no anticipation required for feature buy + avalanche mode
        if (rawData.doubleBombSpins === -1 && rawData.wasFeatureBuy && rawData.mode === GameMode.NORMAL_AVALANCHE) {
            retVal = ArrayHelper.initArrayWithValues(retVal.length, () => {
                return ArrayHelper.initArrayWithValues(retVal[0].length, () => false);
            });

            return retVal;
        }

        // restrict 1st reel to have scatter/dead wild anticipation
        for (let row: number = 0; row < retVal[0].length; row++) {
            retVal[0][row] = false;
        }

        return retVal;
    }
}